import React from "react";
import AtAGlance from "./components/AtAGlance";
import aboutBG from "../../images/background-toolshelf.jpg";
import CompanyHistory from "./components/CompanyHistory";
import ContactInfo from "./components/ContactInfo";
import { Visibility } from "semantic-ui-react";

const AboutIntro = () => (
  <div
    className="section is-medium has-text-light"
    style={{
      backgroundImage: `url('${aboutBG}')`,
      backgroundAttachment: "fixed",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover"
    }}
  >
    <div className="container">
      <div className="columns">
        <div className="column is-5-desktop is-12-touch">
          <h1 className="title is-3 has-text-light">About Accratronics</h1>
          <p>
          Accratronics Seals, LLC. was founded in 1964, specializing in Glass-to-Metal, 
          hermetically-sealed connectors and precision machining. Our work has been on 
          most NASA mission since Gemini II, and is used for thousands of military, 
          aerospace, commercial, medical, and energy applications.
          </p>
        </div>
      </div>
    </div>
  </div>
);

const About = props => (
  <div>
    <Visibility
      onBottomPassed={props.onBottomPassed}
      onBottomPassedReverse={props.onBottomPassedReverse}
      once={false}
    >
      <AboutIntro />
    </Visibility>{" "}
    <AtAGlance />
    <CompanyHistory />
    <ContactInfo />
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/About/About.js